import React, { useState, useEffect } from 'react';
import axios from "axios";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import './AttributesView.css'

import { apiUrl } from '../../../utility/Connections';

import { Typography, Layout, Divider, Button, Input, Modal, Tag, message, Space } from 'antd';
import FileUploaderAuto from '../../../components/fileUploader/fileUploaderAuto';
import LoadingOverlay from '../../../components/loadingOverlay/loadingOverlay';
import Search from '../../../components/search/search';
import { getFromLocalStorage } from '../../../helpers/EncryptData';
import TableLeaderAttributes from '../../../components/tableLeaderAttributes/tableLeaderAttributes';
import { DeleteOutlined, PlusSquareOutlined } from '@ant-design/icons';
import ModalLeaderAttribute from '../../../components/modalLeaderAttribute/modalLeaderAttribute';
const { Paragraph, Title } = Typography;
const { Content } = Layout;

const AttributesView = () => {

    const [fileCharged, setFileCharged] = useState(false)
    const [orgId, setOrgId] = useState(false)
    const [dataLeaderAttributes, setDataLeaderAttributes] = useState([])
    const [filteredDataLeaderAttributes, setFilteredDataLeaderAttributes] = useState([])
    const [searchTextLeaderAttribute, setSearchTextLeaderAttribute] = useState("")
    const [dataLeaderAttributesLevels, setDataLeaderAttributesLevels] = useState([])
    const [selectedFile, setSelectedFile] = useState("")
    const [showLoading, setShowLoading] = useState(false)
    const [loadingText, setLoadingText] = useState("")

    const [newLeaderAttribute, setNewLeaderAttribute] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [showBulkDeleteModal, setShowBulkDeleteModal] = useState(false);
    const [bulkDeleteConfirmCode, setBulkDeleteConfirmCode] = useState("");

    // States para el modal de competencias
    const [latId, setLatId] = useState(null);
    const [latLeaderAttribute, setLatLeaderAttribute] = useState("");
    const [latDescription, setLatDescription] = useState("");
    const [latBehaviors, setLatBehaviors] = useState([]);
    const [dataLeaderAttribute, setDataLeaderAttribute] = useState({});

    const showSwal = (text, type, title) => {
        let swalType = "";
        if (type === 0) {
            swalType = "error";
        }
        if (type === 1) {
            swalType = "warning";
        }
        if (type === 2) {
            swalType = "success";
        }
        withReactContent(Swal).fire({
            title: title,
            icon: swalType,
            text: text,
            confirmButtonColor: "#012E40",
            cancelButtonColor: "#FF4D4F",
        })
    }

    useEffect(() => {
        const current_org = getFromLocalStorage("current_org");
        if (current_org) {
            setOrgId(current_org.org_id);
            getLeaderAttributes(current_org.org_id);
        }
    }, []);

    // Función para asignar valores del backend a los estados
    useEffect(() => {
        if (dataLeaderAttribute) {
            setLatId(dataLeaderAttribute.lat_id || null);
            setLatLeaderAttribute(dataLeaderAttribute.lat_attribute || null);
            setLatDescription(dataLeaderAttribute.lat_description || null);
            setLatBehaviors(dataLeaderAttribute.lat_behaviors || []);
        }
    }, [dataLeaderAttribute]);

    const handleChangeFile = () => {
        setFileCharged(false)
    }

    const selectFile = (files) => {
        setSelectedFile(files[0])
        setFileCharged(true)
    }

    const getLeaderAttributes = async (orgId) => {
        setShowLoading(true);
        setLoadingText("Cargando información. Esto puede tardar un poco...");

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }

        axios.get(`${apiUrl}/leader-attributes/get-leader-attributes/${orgId}/`, headers)
            .then(function (response) {
                const data = response.data;
                setDataLeaderAttributes(data);
                if (searchTextLeaderAttribute) {
                    filterDataLeaderAttribute(searchTextLeaderAttribute, data)
                } else {
                    setFilteredDataLeaderAttributes(data);
                }
                setShowLoading(false);
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    };

    const uploadFile = async () => {
        setShowLoading(true);
        setLoadingText("Guardando competencias. Esto puede tardar un poco...");

        const formData = new FormData();
        formData.append("file", selectedFile);
        formData.append("org_id", orgId);

        const token = localStorage.getItem('access_token');
        
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        }

        axios
            .post(`${apiUrl}/files/upload-leader-attributes/`, formData, headers)
            .then(function (response) {
                // getUploadedFiles();
                resetStates();
                getLeaderAttributes(orgId);
                showSwal(response.data.message, 2, "Correcto");
                setShowLoading(false);
            })
            .catch(function (error) {
                setShowLoading(false)
                showSwal(`Error: ${error}`, 0, "Error");
                console.error(`Error: ${error}`);
            });
    };

    const resetStates = () => {
        setFileCharged(false)
        setSelectedFile("")
    }

    const onSearchLeaderAttribute = (value) => {
        setSearchTextLeaderAttribute(value)
        filterDataLeaderAttribute(value, dataLeaderAttributesLevels)
    }

    const filterDataLeaderAttribute = (value, data) => {
        if (value.trim() === "") {
            setFilteredDataLeaderAttributes(data); // 🔄 Si está vacío, mostrar todo el array original
        } else {
            const filtered = data.filter(item =>
                item.lat_attribute.toLowerCase().includes(value.toLowerCase())
            );
            setFilteredDataLeaderAttributes(filtered);
        }
    }

    const setLeaderAttributeValuesToSee = (lat) => {
        setShowLoading(true);
        setNewLeaderAttribute(false);
        setLoadingText("Cargando información del atributo del líder...")
        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }
        axios
            .get(`${apiUrl}/leader-attributes/get-leader-attribute-by-id/${lat.lat_id}/`, headers)
            .then(function (response) {
                const data = response.data.leader_attribute
                setNewLeaderAttribute(false);
                setModalVisible(true);
                setDataLeaderAttribute(data);
                setShowLoading(false);
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false)
                setLoadingText(null)
            });
    }

    const openNewLeaderAttribute = () => {
        let objLeaderAttribute = {
            lat_id: null,
            lat_attribute: "",
            lat_description: "",
            lat_behaviors: new Array(10).fill(null),
        }
        setDataLeaderAttribute(objLeaderAttribute);
        setNewLeaderAttribute(true);
        setModalVisible(true);
    }

    const saveLeaderAttribute = () => {
        setShowLoading(true);
        setLoadingText("Guardando edición del atributo...")
        setModalVisible(false);

        const formData = new FormData();

        formData.append("lat_org_id", orgId);
        formData.append("lat_id", latId);
        formData.append("lat_attribute", latLeaderAttribute);
        formData.append("lat_description", latDescription);
        formData.append("lat_behaviors", JSON.stringify(latBehaviors));


        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }
        axios
            .post(`${apiUrl}/leader-attributes/save-leader-attribute/`, formData, headers)
            .then(function (response) {
                setNewLeaderAttribute(false);
                showSwal(response.data.message, 2, "Correcto");
                setModalVisible(false);
                getLeaderAttributes(orgId);
                setShowLoading(false);
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setModalVisible(true);
                setShowLoading(false)
                setLoadingText(null)
            });
    }

    const createLeaderAttribute = () => {
        setShowLoading(true);
        setLoadingText("Guardando atributo del líder...")
        const formData = new FormData();

        formData.append("lat_org_id", orgId);
        formData.append("lat_attribute", latLeaderAttribute);
        formData.append("lat_description", latDescription);
        formData.append("lat_behaviors", latBehaviors);

        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }
        axios
            .post(`${apiUrl}/leader-attributes/create-attribute/`, formData, headers)
            .then(function (response) {
                setNewLeaderAttribute(false);
                setModalVisible(false);
                showSwal(response.data.message, 2, "Correcto");
                getLeaderAttributes(orgId);
                // setShowLoading(false);
            })
            .catch(function (error) {
                // showSwal(error.data.error, 0, "Error");
                console.error('There was an error!', error);
                // setModalVisible(true);
                setShowLoading(false)
                setLoadingText(null)
            });
    }

    const bulkDeleteCode = "ELIMINAR";

    const handleBulkDelete = () => {
        if (bulkDeleteConfirmCode !== bulkDeleteCode) {
            message.error(`Debe escribir "${bulkDeleteCode}" para confirmar`);
            return;
        }

        setShowBulkDeleteModal(false);
        setBulkDeleteConfirmCode("");
        setShowLoading(true);
        setLoadingText("Eliminando todos los atributos del líder...");

        const token = localStorage.getItem('access_token');
        const headers = { headers: { Authorization: `Bearer ${token}` } };

        axios
            .delete(`${apiUrl}/leader-attributes/bulk-delete-leader-attributes/${orgId}/`, headers)
            .then(function (response) {
                showSwal(response.data.message, 2, "Eliminación completada");
                getLeaderAttributes(orgId);
                setShowLoading(false);
            })
            .catch(function (error) {
                setShowLoading(false);
                const resp = error.response;
                showSwal(resp?.data?.error || `Error: ${error.message}`, 0, "Error");
            });
    };

    const handleDeleteAllBehaviors = (latId) => {
        const token = localStorage.getItem('access_token');
        const headers = { headers: { Authorization: `Bearer ${token}` } };

        setModalVisible(false);
        setShowLoading(true);
        setLoadingText("Eliminando todos los comportamientos del atributo...");

        axios
            .delete(`${apiUrl}/leader-attributes/bulk-delete-leader-behaviors/${latId}/`, headers)
            .then(function (response) {
                showSwal(response.data.message, 2, "Eliminación completada");
                getLeaderAttributes(orgId);
                setShowLoading(false);
            })
            .catch(function (error) {
                setShowLoading(false);
                const resp = error.response;
                showSwal(resp?.data?.error || `Error: ${error.message}`, 0, "Error");
            });
    };

    return <div className='main-container'>
        {
            showLoading && <LoadingOverlay text={loadingText} showProgress={false} progress={null} />
        }
        <Content className='main-subcontainer main-subcontainer-column'>
            {/* <SideMenuAdmin /> */}
            <div className='layout-content'>
                <Typography className='display-center-row display-center-column'>
                    <Title type='primary' level={3}>Carga de atributos del líder</Title>
                    <Paragraph>
                        Configure y cargue sus archivos desde esta sección. Siga los siguientes pasos:
                        <ol style={{ marginTop: 10, marginBottom: 10 }}>
                            <li>Haz clic en el cargador o arrastra tu archivo a la zona de carga</li>
                            <li>Haz clic en el botón "Cargar atributos del líder"</li>
                        </ol>
                    </Paragraph>
                </Typography>
                <div className='display-center-row display-center-column align-full-center'>
                    <div style={{ width: "80%", backgroundColor: "white" }} className='display-center-row main-subcontainer'>
                        {
                            fileCharged ? <div className='display-center-row display-center-column align-full-center uploader-container' >
                                <p className='filename-tag'>{selectedFile.name}</p>
                                <Button style={{ width: 'auto' }} type="primary" danger onClick={handleChangeFile}>Cambiar archivo</Button>
                            </div> : <div className='display-center-row display-center-column uploader-container'>
                                <FileUploaderAuto mostrarData={selectFile} multi={false} openSwal={showSwal} uploadFile={true} tamanoArchivo={100} />
                            </div>
                        }
                    </div>
                    <Button style={{ width: 'auto' }} type="primary" onClick={uploadFile} disabled={!fileCharged}>Cargar atributos del líder</Button>
                </div>
            </div>
            <Divider />
            <div className='layout-content'>
                <Typography className='display-center-row display-center-column'>
                    <Title type='primary' level={3}>Gestión de atributos del líder</Title>
                </Typography>
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 16 }}>
                    <Space wrap>
                        <Button onClick={openNewLeaderAttribute} icon={<PlusSquareOutlined />}>Crear atributo del líder</Button>
                        {dataLeaderAttributes.length > 0 && (
                            <Button
                                danger
                                icon={<DeleteOutlined />}
                                onClick={() => { setShowBulkDeleteModal(true); setBulkDeleteConfirmCode(""); }}
                            >
                                {`Eliminar todos los atributos (${dataLeaderAttributes.length})`}
                            </Button>
                        )}
                    </Space>
                </div>
                <Divider />
                <Search onSearch={onSearchLeaderAttribute} />
                <br></br>
                <div className='display-center-row display-center-column'>
                    <TableLeaderAttributes data={filteredDataLeaderAttributes} setLeaderAttributeValuesToSee={setLeaderAttributeValuesToSee} />
                </div>
            </div>
        </Content>
        <ModalLeaderAttribute
            visible={modalVisible}
            onClose={() => setModalVisible(false)}
            states={{
                latId, latLeaderAttribute, latDescription, latBehaviors
            }}
            setters={{
                setLatId, setLatLeaderAttribute, setLatDescription, setLatBehaviors
            }}
            newLeaderAttribute={newLeaderAttribute}
            saveLeaderAttribute={saveLeaderAttribute}
            createLeaderAttribute={createLeaderAttribute}
            onDeleteAllBehaviors={handleDeleteAllBehaviors}
        />

        <Modal
            title={`Eliminar todos los atributos del líder (${dataLeaderAttributes.length})`}
            open={showBulkDeleteModal}
            onCancel={() => setShowBulkDeleteModal(false)}
            onOk={handleBulkDelete}
            okText="Confirmar eliminación"
            cancelText="Cancelar"
            okButtonProps={{ danger: true, disabled: bulkDeleteConfirmCode !== bulkDeleteCode }}
            destroyOnClose
        >
            <Typography.Text style={{ display: 'block', marginBottom: 12 }}>
                Esta acción eliminará todos los {dataLeaderAttributes.length} atributos del líder y sus comportamientos asociados. Esta acción no se puede deshacer.
            </Typography.Text>
            <Typography.Text strong style={{ display: 'block', marginBottom: 8 }}>
                Escriba <Tag color="red">{bulkDeleteCode}</Tag> para confirmar:
            </Typography.Text>
            <Input
                value={bulkDeleteConfirmCode}
                onChange={(e) => setBulkDeleteConfirmCode(e.target.value)}
                placeholder={`Escriba ${bulkDeleteCode}`}
                onPressEnter={handleBulkDelete}
            />
        </Modal>
    </div>
}

export default AttributesView;